import { Button, ChakraSelect, FormControl, FormLabel, HStack, Stack, useDisclosure } from '@elkaso-app/web-design';
import { useGetPublishersApi } from 'apis/campaigns/use-get-publishers-api';
import { BaseFilterButton } from 'components/base-table/filters';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

type TOption = {
  value: string;
  label: string;
};

type TInputs = {
  publisherIds: TOption | undefined;
};

const defaultValues: TInputs = {
  publisherIds: undefined,
};

export const PublisherIdsFilterButton = () => {
  const [publisherIds, setIsPublisherIds] = useState<string | undefined>(undefined);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();
  const { data: publishers = [] } = useGetPublishersApi();

  const publisherOptions = publishers?.map((publisher) => {
    return { value: publisher.id.toString(), label: publisher.name };
  });

  useEffect(() => {
    setIsPublisherIds((params?.publisherIds as string) ?? '');
  }, [params.publisherIds]);

  const { control, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  const updateValues = () => {
    setValue(
      'publisherIds',
      publisherOptions.find((o) => {
        if (params?.publisherIds) {
          return o.value === params?.publisherIds;
        }

        return undefined;
      })
    );
  };

  useEffect(() => {
    updateValues();
  }, [params.publisherIds]);

  const onSubmit = (data: TInputs) => {
    params.publisherIds = data?.publisherIds?.value as string;

    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => {
    const isDisabled = Object.keys(formState.dirtyFields).length ? false : true;
    return isDisabled;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={!!publisherIds}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name='publisherIds'
            render={({ field: { onChange, name, onBlur, value } }) => (
              <FormControl>
                <FormLabel>Publisher</FormLabel>
                <ChakraSelect
                  id='publisherIds'
                  options={publisherOptions}
                  onChange={onChange}
                  name={name}
                  onBlur={onBlur}
                  value={value}
                />
              </FormControl>
            )}
          />

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
